module.exports = __webpack_public_path__ + "img/cl.5922ecc9.jpg";